import React from 'react';
import BtnPrimary from "../../../../shared/ui/button/primary/BtnPrimary";
import ModalCustom from "../../../../shared/ui/modal/ModalCustom";
import {formatDate} from "../CloseDays";

const ModalDeleteCloseDayConfirm = ({confirmHandler, closeHandler, data}: any) => {
    return (
        <ModalCustom title={"Conferma cancellazione giorno chiusura"} closeModal={closeHandler}
                     footerTemplate={<div className={'btn-row'}>
                         <BtnPrimary onClick={closeHandler}
                                     variant={'outline-primary'}
                                     className={'text-primary'}>Annulla</BtnPrimary>
                         <BtnPrimary onClick={confirmHandler}>Conferma</BtnPrimary>
                     </div>}>
            <p>Confermi la cancellazione del giorno chiusura {formatDate(data)}?</p>
        </ModalCustom>
    );
};

export default ModalDeleteCloseDayConfirm;
